import { RegionalPriceType } from './regional-price.type';

export interface BaseSubscriptionPlan {
  id: string;
  tier: SubscriptionTier;
  benefits: PlanBenefit[];
  displayName: string;
  price: string;
  expiredIn?: string;
  title: string;
  moreInfoItems: PlanBenefit[];
}

export interface PlanBenefit {
  content: string | React.ReactNode;
  subContent: React.ReactNode[];
  featured: boolean;
}

export enum SubscriptionTier {
  BRONZE = 'BRONZE',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
}

export interface PlanResponseData {
  id: number;
  external_id: string;
  name: {
    en: string;
  };
  description: {
    en: string;
  };
  localized_name: string;
  charge: {
    period: {
      value: number;
      type: string;
    };
    amount: number;
    currency: string;
    prices?: {
      amount: number;
      currency: string;
      setup_fee: number;
    }[];
  };
  status: {
    value: string;
  };
  benefits?: {
    name: SubscriptionBenefitType;
  }[];
  regionalPrice?: RegionalPriceType;
}

export interface UserSubscriptionPlan {
  external_id: string;
  id: string;
  date_next_charge?: string;
  status: 'active' | 'non_renewing' | 'canceled';
  benefits?: {
    name: SubscriptionBenefitType;
  }[];
}

export interface SubscriptionPlanResponse {
  data: PlanResponseData[];
}

export interface UserSubscriptionPlanResponse {
  data: UserSubscriptionPlan[];
}

export interface CheckoutResponse {
  data: { token: string };
}
export type SubscriptionPlanBlueprint = Record<
  SubscriptionTier,
  {
    benefits: PlanBenefit[];
    title: string;
    moreInfoItems: PlanBenefit[];
  }
>;

export interface EnhancedSubscriptionPlan extends BaseSubscriptionPlan {
  xsollaPlanId: number;
  priority: number;
  externalId: string;
  rawPlan: PlanResponseData;
  shortName: string;
}

export interface CurrentSubscriptionPlan extends EnhancedSubscriptionPlan {
  subscriptionId: string;
}

export const SubscriptionBenefits = {
  freePull: 'freePull',
  pullPity: 'pullPity',
  mission: 'mission',
  clubStoreAccess: 'clubStoreAccess',
} as const;

export type SubscriptionBenefitType =
  (typeof SubscriptionBenefits)[keyof typeof SubscriptionBenefits];
